import { render } from "./ConteudosProgramaticos.vue?vue&type=template&id=66ce664c&scoped=true"
import script from "./ConteudosProgramaticos.vue?vue&type=script&lang=js"
export * from "./ConteudosProgramaticos.vue?vue&type=script&lang=js"

import "./ConteudosProgramaticos.vue?vue&type=style&index=0&id=66ce664c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ce664c"]])

export default __exports__